import {Container, Paper, Snackbar, TableBody, TableHead} from "@mui/material";
import {
    StyledAlert,
    StyledButtonOrange,
    StyledTable, StyledTableBodyRow,
    StyledTableCell, StyledTableCellHeader, StyledTableContainer,
    StyledTableHeadRow
} from "../../styles/MyStyles";
import React, {useEffect, useState} from "react";
import * as DataProvider from "../../logic/DataProvider";
import dayjs from "dayjs";
import {GetEnumValueName} from "../../logic/EnumHelper";
import {GetOrderTitle} from "../../logic/EntityTitleHelper";
import {GetLookupValueName} from "../../logic/LookupHelper";
import * as ConfirmationDownloader from "../../logic/ConfirmationDownloader";


const TradesPage = () => {
    const [trades, setTrades] = useState([]);
    const [orders, setOrders] = useState([]);
    const [snackbar, setSnackbar] = React.useState({
        open: false,
        vertical: 'top',
        horizontal: 'center',
        message: ''
    });

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = () => {
        try {
            let bundle = DataProvider.GetClientBundle();
            if (bundle.orders) {
                let entities = bundle.orders;
                setOrders(JSON.parse(JSON.stringify(entities)));
            }
            if (bundle.trades) {
                let entities = bundle.trades;
                setTrades(JSON.parse(JSON.stringify(entities)));
            }
        } catch (error) {
            console.log('An error occurred:', error);
        }
    };

    const handleCloseSnackbar = () => {
        setSnackbar({ ...snackbar, open: false });
    };

    return (
        <Container sx={{ margin: '0.2rem', minWidth: '99%' }}>
            <Snackbar
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                open={snackbar.open}
                autoHideDuration={6000}
                onClose={handleCloseSnackbar}>
                <StyledAlert onClose={handleCloseSnackbar} severity="error" sx={{ width: '100%' }}>
                    {snackbar.message}
                </StyledAlert>
            </Snackbar>
            <StyledTableContainer component={Paper}>
                <StyledTable>
                    <TableHead>
                        <StyledTableHeadRow>
                            <StyledTableCellHeader columncount={9}>Date</StyledTableCellHeader>
                            <StyledTableCellHeader columncount={9}>Order</StyledTableCellHeader>
                            <StyledTableCellHeader columncount={9}>Action</StyledTableCellHeader>
                            <StyledTableCellHeader columncount={9}>Crypto Amount</StyledTableCellHeader>
                            <StyledTableCellHeader columncount={9}>Price</StyledTableCellHeader>
                            <StyledTableCellHeader columncount={9}>Brokerage Fee</StyledTableCellHeader>
                            <StyledTableCellHeader columncount={9}>Transaction Fee</StyledTableCellHeader>
                            <StyledTableCellHeader columncount={9}>Fee Asset</StyledTableCellHeader>
                            <StyledTableCellHeader columncount={9}></StyledTableCellHeader>
                        </StyledTableHeadRow>
                    </TableHead>
                    <TableBody>
                        {trades && trades.map((trade) => (
                            <StyledTableBodyRow key={trade.id}>
                                <StyledTableCell>{dayjs(trade.date).toDate().toDateString()}</StyledTableCell>
                                <StyledTableCell>{GetOrderTitle(orders.find(e => e.id === trade.orderId))}</StyledTableCell>
                                <StyledTableCell>{GetEnumValueName('orderAction', orders.find(e => e.id === trade.orderId)?.action)}</StyledTableCell>
                                <StyledTableCell>{trade.cryptoAmount}</StyledTableCell>
                                <StyledTableCell>{trade.price}</StyledTableCell>
                                <StyledTableCell>{trade.brokerageFee}</StyledTableCell>
                                <StyledTableCell>{trade.transactionFee}</StyledTableCell>
                                <StyledTableCell>{GetLookupValueName('asset', trade.feeAssetId)}</StyledTableCell>
                                <StyledTableCell>
                                    <StyledButtonOrange
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            ConfirmationDownloader.GenerateTradeConfirmation(trade.id, snackbar, setSnackbar);
                                        }}>
                                        Confirmation
                                    </StyledButtonOrange>
                                </StyledTableCell>
                            </StyledTableBodyRow>
                        ))}
                    </TableBody>
                </StyledTable>
            </StyledTableContainer>
        </Container>
    );
};
export default TradesPage;